export default function isMobile() {
  return window.innerWidth < 768;
}



// WEBPACK FOOTER //
// ./src/initialiser/isMobile.js